import React, { useEffect, useState } from 'react';
import Form, {
  Item as FormItem,
  GroupItem,
  ColCountByScreen,
} from 'devextreme-react/form';
import SelectBox from 'devextreme-react/select-box';
import TextArea from 'devextreme-react/text-area';
import { FormTextbox, FormPhotoUploader } from '../..';
import { getSizeQualifier } from '../../../utils/media-query';
import { nameserver } from '../../../config/nameServer';
import { DateBox } from 'devextreme-react';
export const ContactEditForm = ({ initData, onDataChanged }) => {
  const [data, setData] = useState(initData);
  const [trangThai, setTrangThai] = useState<number | null>(null);
  const [deXuat, setDeXuat] = useState('');
  const [trangThaiThietBi, setTrangThaiThietBi] = useState<number | null>(null);
  const [fullName] = useState(localStorage.getItem('fullname') || '');

  const trangThaiThietBiList = [
    { id: 1, name: 'Đang chạy' },
    { id: 2, name: 'Thiết bị dừng' },
  ];
  const API_URL = nameserver;
  useEffect(() => {
    if (!initData) return;

    const mappedData = {
      ...initData,
      KET_QUA: initData.KET_QUA,
      TRANG_THAI_THIET_BI: initData.TRANG_THAI,
    };
    console.log('initdata ',initData);
    
    setData(mappedData);

    // ✅ FIX CHÍNH Ở ĐÂY
    if (mappedData.KET_QUA === 'OK') setTrangThai(1);
    else if (mappedData.KET_QUA === 'Not OK') setTrangThai(2);
    else setTrangThai(null); // 🔥 QUAN TRỌNG

    // Trạng thái thiết bị
    if (mappedData.TRANG_THAI_THIET_BI === 'Đang chạy') setTrangThaiThietBi(1);
    else if (mappedData.TRANG_THAI_THIET_BI === 'Thiết bị dừng')
      setTrangThaiThietBi(2);
    else setTrangThaiThietBi(null); // 🔥 thêm luôn

    setDeXuat(mappedData.DE_XUAT || '');

    onDataChanged(mappedData);
  }, [initData]);

  const trangThaiList = [
    { id: 1, name: 'OK' },
    { id: 2, name: 'Not OK' },
  ];

  return (
    <Form formData={data} screenByWidth={getSizeQualifier}>
      <GroupItem>
        <ColCountByScreen xs={1} sm={2} md={2} lg={2} />

        <FormItem>
          <FormTextbox
            label='Thiết bị'
            value={data.TEN_THIET_BI}
            isEditing={false}
          />
        </FormItem>

        <FormItem>
          <FormTextbox
            label='Bộ phận'
            value={data.TEN_BO_PHAN}
            isEditing={false}
          />
        </FormItem>
      </GroupItem>

      <GroupItem>
        <FormItem>
          <FormTextbox
            label='Nội dung kiểm tra'
            value={data.NOI_DUNG_KIEM_TRA}
            isEditing={false}
          />
        </FormItem>

        <FormItem>
          <FormTextbox
            label='Phương pháp kiểm tra'
            value={data.PHUONG_PHAP_KIEM_TRA}
            isEditing={false}
          />
        </FormItem>

        <FormItem>
          <FormTextbox
            label='Tiêu chuẩn'
            value={data.TIEU_CHUAN}
            isEditing={false}
          />
        </FormItem>
      </GroupItem>
      <GroupItem>
        <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
        <FormItem>
          <FormTextbox
            label='Người kiểm tra'
            value={data.CREATED_BY}
            isEditing={false}
          />
        </FormItem>
        <FormItem>
  <DateBox
    label='Ngày kiểm tra'
    type='datetime'
    value={data.NGAY_SUA}
    displayFormat='dd/MM/yyyy HH:mm:ss'
    // onValueChanged={(e) =>
    //   updateData({
    //     ...data,
    //     NGAY_SUA: e.value,
    //   })
    // }
    readOnly={true}
  />
</FormItem>
      </GroupItem>
      <GroupItem>
        <ColCountByScreen xs={1} sm={3} md={3} lg={3} />
        <FormItem>
          <FormTextbox
            label='Tuần tra cấp'
            value={`Tuần tra cấp ${data.CAP_TUAN_TRA}`}
            isEditing={false}
          />
        </FormItem>

        <FormItem>
          <FormTextbox label='Ca' value={`Ca ${data.CA}`} isEditing={false} />
        </FormItem>
        <FormItem label={{ text: 'OK/NotOK' }}>
          <SelectBox
            dataSource={trangThaiList}
            displayExpr='name'
            valueExpr='id'
            value={trangThai}
            onValueChanged={(e) => {
              const statusName = e.component.option('selectedItem').name;

              setTrangThai(e.value);

              let newData = {
                ...data,
                KET_QUA: statusName,
              };

              // ✅ OK → reset sạch
              if (statusName === 'OK') {
                newData = {
                  ...newData,
                  ANH: null,
                  DE_XUAT: '',
                  TRANG_THAI_THIET_BI: 'Đang chạy',
                };

                setTrangThaiThietBi(1);
                setDeXuat('');
              }

              // ✅ Not OK
              if (statusName === 'Not OK') {
                newData.TRANG_THAI_THIET_BI = 'Thiết bị dừng';
                setTrangThaiThietBi(2);
              }

              setData(newData);
              onDataChanged(newData);
            }}
          />
        </FormItem>
        {data?.KET_QUA === 'Not OK' && (
          <FormItem label={{ text: 'Trạng thái thiết bị' }}>
            <SelectBox
              dataSource={trangThaiThietBiList}
              displayExpr='name'
              valueExpr='id'
              value={trangThaiThietBi}
              onValueChanged={(e) => {
                const deviceStatus = e.component.option('selectedItem').name;

                setTrangThaiThietBi(e.value);

                const newData = {
                  ...data,
                  TRANG_THAI_THIET_BI: deviceStatus,
                };

                setData(newData);
                onDataChanged(newData);
              }}
            />
          </FormItem>
        )}
      </GroupItem>

      <GroupItem>
        <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
        <FormItem>
          <FormPhotoUploader
            key={data?.ID || 'new'}
            onUploaded={(url) => {
              const newData = {
                ...data,
                ANH: url,
              };
              setData(newData);
              onDataChanged(newData);
            }}
          />
          {data?.ANH ? (
            <div style={{ marginTop: 10 }}>
              <img
                src={
                  data.ANH
                    ? data.ANH.startsWith('http')
                      ? data.ANH
                      : API_URL + data.ANH
                    : ''
                }
                alt='preview'
                style={{ width: 200, borderRadius: 8 }}
              />
            </div>
          ) : (
            <div style={{ marginTop: 10, color: '#999' }}>Không có ảnh</div>
          )}
        </FormItem>

        <FormItem label={{ text: 'Đề xuất sửa chữa' }}>
          <TextArea
            height={90}
            value={deXuat || ''}
            onValueChanged={(e) => {
              setDeXuat(e.value);

              const newData = {
                ...data,
                DE_XUAT: e.value,
              };

              setData(newData);
              onDataChanged(newData);
            }}
          />
        </FormItem>
      </GroupItem>
    </Form>
  );
};
